import React from 'react';
import { observer } from 'mobx-react';

export default observer((props) => {
  const store = props.store;
  return (
    <span className="take-off">
      请拿开读卡器&nbsp;&nbsp; <span className="take-off-countdown">{store.count}s</span>&nbsp;&nbsp;<a className="take-off-btn" onClick={() => { store.skipOver = true; }}>点击跳过</a>
    </span>
  );
});
